import { render, staticRenderFns } from "./SettingsUpdated.vue?vue&type=template&id=09916b4b&scoped=true"
import script from "./SettingsUpdated.vue?vue&type=script&lang=js"
export * from "./SettingsUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09916b4b",
  null
  
)

export default component.exports